import { ProjectGoal } from '@/app/models/project';
import { Data, getComparator, Order } from '@/pages/buildingsTotal';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProjectsTotalTableProps {
  goals: ProjectGoal[];
}

function ProjectsTotalTable(props: ProjectsTotalTableProps) {
  const { goals } = props;
  const { t } = useTranslation(['buildingsTotal', 'common']);

  const formatter = new Intl.NumberFormat('pt-BR');

  const [orderGoals, setOrderGoals] = React.useState<Order>('desc');
  const [orderByGoals, setOrderByGoals] = React.useState<keyof Data>('value');

  const handleRequestSortGoals = (property: keyof Data) => {
    const isAsc = orderByGoals === property && orderGoals === 'asc';
    setOrderGoals(isAsc ? 'desc' : 'asc');
    setOrderByGoals(property);
  };
  const visibleGoals = React.useMemo(() => {
    if (!goals) return [];
    const stabilized = [...goals];
    return stabilized.sort((a, b) => getComparator(orderGoals, 'goal')(a, b));
  }, [goals, orderGoals]);

  return (
    <div style={{ width: '40%' }}>
      <TableContainer sx={{ height: '25rem' }} component={Paper}>
        <Table stickyHeader size="small" aria-label="Expense Table">
          <TableHead sx={{ fontWeight: 700 }}>
            <TableRow>
              <TableCell align="left" style={{ fontWeight: 'bold' }}>
                {t('project')}
              </TableCell>
              <TableCell align="left" style={{ fontWeight: 'bold' }}>
                <TableSortLabel
                  active={orderByGoals === 'value'}
                  direction={orderByGoals === 'value' ? orderGoals : 'asc'}
                  onClick={() => handleRequestSortGoals('value')}
                  style={{ fontWeight: 'bold' }}
                >
                  {t('value')}
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {goals &&
              visibleGoals.map((row: ProjectGoal) => (
                <TableRow key={`${row.project.code} - ${row.project.name}`}>
                  <TableCell>{`${row.project.code} - ${row.project.name}`}</TableCell>
                  <TableCell>{`R$ ${formatter.format(row.goal)}`}</TableCell>
                </TableRow>
              ))}
            {goals?.length === 0 && (
              <TableRow>
                <TableCell sx={{ textAlign: 'center' }} colSpan={8}>
                  {t('common:no.results.found')}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <Typography sx={{ alignSelf: 'end', marginTop: '1rem', marginRight: '5rem', fontWeight: 'bold' }}>
          {`${t('Total')}: ${`R$ ${formatter.format(goals?.reduce((acc, item) => acc + item.goal, 0) as number)}`}`}
        </Typography>
      </div>
    </div>
  );
}

export default ProjectsTotalTable;
